import { Stack } from "@mui/system"
import Layout from "../../components/Layout"
import { Box, Grid } from "@mui/material"
import GroupInfo from "../../components/GroupProfile/GroupInfo"
import GroupOverviewBox from "../../components/GroupProfile/GroupOverview/GroupOverviewBox"
import RecentActivity from "../../components/GroupProfile/RecentActivity"
import { useDispatch, useSelector } from "react-redux"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import { useNavigate } from "react-router"
import { useEffect } from "react"
import GroupProfileHeader from "../../components/Headers/GroupProfileHeader"
import { GPStack } from "./Atom"
import AdminAPI from "../../../api/admin"
import { getTokenLocal, makeFullName } from "../../../helper/utils"
import { useResponseHandle } from "../../hooks"
import {
  setAdvisorsData,
  setCsmData,
  setGaData,
  setOfficeManagersData,
} from "../../redux/slices/usersSlice"
import GroupProfileAPI from "../../../api/groupProfile"
import {
  setGroupInfo,
  updatePracticeList,
} from "../../redux/slices/groupProfileSlice"

const adminAPI = new AdminAPI()
const groupProfileAPI = new GroupProfileAPI()

function GroupProfile() {
  const token: any = getTokenLocal()

  const dispatch = useDispatch()
  const navigate = useNavigate()
  dispatch(setOpenSidebar(false))

  const selectedGroupSk = useSelector((state: any) => {
    return state.groupProfile.selectedGroupSk
  })

  const groupInfo = useSelector((state: any) => {
    return state.groupProfile.groupInfo
  })

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  const groupInfoHandler = async (group_sk: any) => {
    const response = await groupProfileAPI.getgroupInfoById(token, group_sk)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setGroupInfo(result?.data))
      return result
    } else {
      navigate("/auth")
    }
  }

  useEffect(() => {
    if (selectedGroupSk === null) {
      navigate("/customer")
    }
  }, [selectedGroupSk])

  const assignPrimaryContact = async (groupSk: any, gaId: any) => {
    dispatch(setLoading(true))
    const response = await groupProfileAPI.updatePc(token, { groupSk, gaId })

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      // if (result?.statusCode == 200) {
      //   dispatch(setCsmData(result?.data));
      // }
    } else {
      navigate("/auth")
    }
    dispatch(setLoading(false))
    return result
  }

  const assignAdvisor = async (groupSk: any, advisorId: any) => {
    dispatch(setLoading(true))
    const response = await groupProfileAPI.updateAdvisor(token, {
      groupSk,
      advisorId,
    })

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      // if (result?.statusCode == 200) {
      //   dispatch(setCsmData(result?.data));
      // }
    } else {
      navigate("/auth")
    }
    dispatch(setLoading(false))
    return result
  }

  const assignCsm = async (groupSk: any, csmId: any) => {
    dispatch(setLoading(true))
    const response = await groupProfileAPI.updateCsm(token, { groupSk, csmId })

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      // if (result?.statusCode == 200) {
      //   dispatch(setCsmData(result?.data));
      // }
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
    return result
  }
  const updatePracticeStatus = async (practice: any) => {
    dispatch(setLoading(true))
    const response = await groupProfileAPI.changePracticeStatus(
      token,
      practice.practice_sk,
      practice.practice_status == "active" ? "inactive" : "active",
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(updatePracticeList(practice.practice_sk))
      }
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
    return result
  }

  useEffect(() => {
    // fetchAllGroupAdmins()
    // fetchAllAdvisors()
    // fetchAllCsm()
  }, [])

  return (
    <Box>
      <GroupProfileHeader name="Group Profile" />
      <GPStack display={"flex"} spacing={2} direction={"row"}>
        <Grid sx={{ flex: 1 }}>
          <GroupInfo
            groupInfoHandler={groupInfoHandler}
            assignPrimaryContact={assignPrimaryContact}
            assignAdvisor={assignAdvisor}
            assignCsm={assignCsm}
          />
        </Grid>
        <Grid sx={{ flex: 3, "& .css-1fe2d8g": { overflowY: "auto" } }}>
          <GroupOverviewBox updatePracticeStatus={updatePracticeStatus} />
        </Grid>
        {/* <Grid sx={{ flex: 1 }}>
          <RecentActivity />
        </Grid> */}
      </GPStack>
    </Box>
  )
}

export default GroupProfile
